import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 4v16h18V4H3zm16 14H5V8h14v10z"
}), 'WebAssetSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/WebAssetSharp.js
// module id = 7249
// module chunks = 2